export const API_URI = `${process.env.API_HOST}${process.env.API_BASE_PATH}`;
